import { render, staticRenderFns } from "./compulsoryDialog.vue?vue&type=template&id=5c702818"
import script from "./compulsoryDialog.vue?vue&type=script&lang=js"
export * from "./compulsoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports